import ExpeditionCategs from "features/ExpeditionCategory/ExpeditionCategList/ExpeditionCategories";

const ExpeditionCategoryPage: React.FC = () => {
    return <ExpeditionCategs />
  };
  export default ExpeditionCategoryPage;